import { docTypes } from '../enums/docTypes';

export const coerceDocType = (raw: unknown, fallback: docTypes): docTypes => {
  const value = Array.isArray(raw) ? raw[0] : raw;

  if (typeof value !== 'string') {
    return fallback;
  }

  return (Object.values(docTypes) as string[]).includes(value) ? (value as docTypes) : fallback;
};

